// Streak makeup API (ROO-221): repair a missed day after finishing a
// makeup quiz. Mirrors the axios+token pattern used across src/api.

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

function authHeaders() {
  const token =
    localStorage.getItem('cleveroo_token') ||
    localStorage.getItem('accessToken') ||
    '';
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export interface WeeklyHabitDay {
  day: string;
  status: 'done' | 'madeup' | 'missed' | 'today' | 'pending';
  date: string; // YYYY-MM-DD
}

export interface MakeupResult {
  madeUp?: string;
  alreadyActive?: boolean;
  weeklyHabit?: WeeklyHabitDay[];
  streakDays?: number;
}

/** Claim a missed day after completing the makeup quiz. */
export async function redeemStreakMakeup(
  studentId: string,
  date: string,
): Promise<MakeupResult> {
  const res = await axios.post(
    `${API_BASE_URL}/api/students/${studentId}/streak/makeup`,
    { date },
    { headers: { 'Content-Type': 'application/json', ...authHeaders() } },
  );
  return res.data?.data ?? {};
}
